import {UserManager, UserManagerSettings} from 'oidc-client-ts';
import {AAIEDUEnv, REDIRECT_KEY} from '../constants';

class OIDCService {
    private userManager: UserManager;

    constructor(env: UserManagerSettings) {
        this.userManager = new UserManager(env);
    }

    public async login(): Promise<void> {
        localStorage.setItem(REDIRECT_KEY, window.location.pathname + window.location.search);
        await this.userManager.signinRedirect();
    }

    public logout(): Promise<void> {
        return this.userManager.signoutRedirect();
    }
}
export const aaiEduOidcService = new OIDCService(AAIEDUEnv);
